/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  MicrosoftClarity,
  getClientSideCookieConsent,
} from '@lsac/lsac-design-system';
import { createClarityConfig } from '../../helpers/telemetryHelper';
import { config as staticConfig } from '../../config';

// session reducer stores the last fetched server config at `state[athenaSession].config`.
// We want to re-derive clarity config whenever that value changes.

const ClarityMountBase = ({ serverConfig }) => {
  // Always derive from the globally mutated staticConfig.
  // We subscribe to serverConfig only to trigger re-render when it changes.
  const clarityConfig = React.useMemo(() => createClarityConfig(staticConfig), [
    serverConfig,
  ]);

  if (
    clarityConfig.MICROSOFT_CLARITY_ENABLED !== 'true' ||
    !clarityConfig.MICROSOFT_CLARITY_ID
  ) {
    return <></>;
  }

  // Check if Microsoft Clarity script is already loaded
  const existingClarityScript =
    document.querySelector('script[src*="clarity.ms"]') ||
    document.querySelector('script[src*="c.clarity.ms"]') ||
    window.clarity; // Check if clarity global exists

  if (existingClarityScript) {
    return <></>;
  }

  const consentRequired =
    clarityConfig.MICROSOFT_CLARITY_REQUIRES_CONSENT === 'true';
  const hasConsent = consentRequired
    ? getClientSideCookieConsent(clarityConfig.CONSENT_COOKIE_NAME)
    : true;

  return (
    <MicrosoftClarity
      id={clarityConfig.MICROSOFT_CLARITY_ID}
      hasConsent={hasConsent}
      config={clarityConfig}
    />
  );
};

const mapStateToProps = createStructuredSelector({
  serverConfig: state => state?.athenaSession?.config,
});

export default connect(mapStateToProps)(ClarityMountBase);
ClarityMountBase.propTypes = {
  serverConfig: PropTypes.object,
};
